import React from "react";
import { Typography, Box, Paper, Button } from "@mui/material";
import tbc from "../../images/tbc.png";
import bog from "../../images/bog.png";
import { useAppContext } from "../../context";


export default function ChooseBank() {
    const { bank, setBank, setCreateOrder, createOrder } = useAppContext();


    const chooseBank = (selectedBank: number) => {
        
        setBank(selectedBank);
        setCreateOrder({
                ...createOrder,
            openBankingLinkProvider: selectedBank === 1 ? 'TBC' : 'BOG',
        });

    };

    return (
        <>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "1fr 1fr",
                    },
                    gap: 3,
                    mb: 4,
                    maxWidth: 650,
                    width: "100%",
                    mx: "auto",
                }}
            >
                {/* TBC */}
                <Paper
                    sx={{
                        // width: "100%",
                        p: 3,
                        borderRadius: "16px",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        border: bank === 1 ? `2px solid #F95A4E` : "2px solid transparent",
                    }}
                    elevation={2}
                >
                    <img src={tbc} alt="TBC" style={{ maxWidth: "180px", height: "auto" }} />

                    <Button
                        className="font-helviteca"
                        variant="contained"
                        fullWidth
                        sx={{
                            borderRadius: "10px",
                            background: "#1C3553",
                            ":hover": { background: "#172A42" },

                        }}
                        onClick={() => { chooseBank(1) }}
                    >
                        არჩევა
                    </Button>
                </Paper>

                {/* BOG */}
                <Paper
                    sx={{
                        // width: "100%",
                        p: 3,
                        borderRadius: "16px",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        border: bank === 2 ? `2px solid #F95A4E` : "2px solid transparent",
                    }}
                    elevation={2}
                >
                    <img src={bog} alt="BOG" style={{ maxWidth: "180px", height: "auto" }} />

                    <Button
                        className="font-helviteca"
                        variant="contained"
                        fullWidth
                        sx={{
                            borderRadius: "10px",
                            background: "#1C3553",
                            ":hover": { background: "#172A42" },

                        }}
                        onClick={() => { chooseBank(2);  }}
                    >
                        არჩევა
                    </Button>
                </Paper>
            </Box>

        </>
    );
}